<template>
  <div
    :style="{
      backgroundImage: 'url(' + srcImgUrl + ')',
      backgroundSize: '100% 100%',
      backgroundRepeat: 'no-repeat',
      overflow: 'hidden',
      height: '100%',
    }"
  >
    <div class="conter">
      <div class="time">
        <p v-if="start">{{ time }}</p>
        <div v-else>
          <img src="../../assets/stormPassAnswer/right.png" alt style="width: 100%" v-if="type" />
          <img src="../../assets/stormPassAnswer/error.png" alt v-else style="width: 100%" />
        </div>
      </div>
      <div v-for="(ele, int) in questionList" class="questionList" v-show="num == int">
        <p class="order">
          <span class="num">{{ int+1 }}</span>/
          <span class="all">{{ questionList.length }}</span>
        </p>
        <p class="quesName">{{ ele.webBtQuestionInfo }}</p>
        <ul class="answer">
          <li
            v-for="(item, index) in ele.webBtanswerEntities"
            :key="index"
            @click="answerStart(ele.webBtQuestionId, int, index,item.webBtAnswerId)"
            :class="[rightId == item.webBtAnswerId ? 'right' : item.error ? 'error' : '']"
            :style="{'pointer-events': disable?'none':''}"
          >
            <span>{{ item.webBtAnswerInfo }}</span>
            <!-- 正确答案 -->
            <img v-if="item.right" src="../../assets/stormPassAnswer/Frame.png" alt srcset />
            <!-- 错误答案 -->
            <img src="../../assets/stormPassAnswer/Frame1.png" alt v-if="item.error" />
          </li>
        </ul>
      </div>
    </div>
    <div class="bot"></div>
    <!-- 解析 -->
    <van-action-sheet
      v-if="show"
      v-model:show="show"
      :close-on-click-overlay="false"
      style="max-width: 460px; left: 50%; transform: translateX(-50%)"
    >
      <div class="analysis" v-if="questionList.length>0">
        <p class="correct">
          <span>正确答案：</span>
          <span>{{ questionList[num].webBtanswerEntities[rightIndex].webBtAnswerInfo }}</span>
        </p>
        <div>
          解析：
          {{
          webBtAnswerAnalysis
          }}
        </div>
        <van-button
          color="#FEB13C"
          round
          style="
            width: 51.5%;
            margin: 0 auto;
            display: block;
            margin-top: 1.2rem;
          "
          @click="onClose"
        >我知道了</van-button>
      </div>
    </van-action-sheet>
    <!-- 闯关详情 -->
    <van-popup
      :close-on-click-overlay="false"
      v-model:show="showCenter"
      round
      :style="{
        width: '6.22rem',
        padding: '.6rem .4rem .8rem',
        boxSizing: ' border-box',
      }"
    >
      <p class="details">{{ throughType ? "恭喜您闯关成功" : "很遗您憾闯关失败" }}</p>
      <div class="through">
        <img
          :src="
            throughType
              ? require('../../assets/stormPassAnswer/succ.png')
              : require('../../assets/stormPassAnswer/ku.png')
          "
          alt
          style="padding: 0.6rem 0 0.4rem 0"
        />
        <p class="score">
          本次答题
          <span>＋{{ allNum }}</span>&nbsp;&nbsp; 分
        </p>
        <div class="but">
          <van-button
            round
            @click="next"
            style="
              width: 2.54rem;
              flex-grow: 1;
              color: #feb13c !important;
              background-color: #fdf2e3 !important;
              margin-right:17px
            "
          >返回首页</van-button>
          <van-button
            color="#FEB13C"
            round
            @click="nextRound"
            style="width: 2.54rem"
            v-if="(this.detailData.webAnswerCountLimitNum!=1 &&this.detailData.webAnswerCountLimitFlag == 1)||(this.detailData.webAnswerCountLimitNum==1 &&this.detailData.webAnswerCountLimitFlag == 2)"
          >再来一局</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  getBreakthroughQuestion,
  getBreakthroughAnswer
} from "@/api/stormPassAnswer";
import { List, Dialog, Toast } from "vant";
import { filePerviewPath } from "@/api/ActivitySolicitation/index.js";
import { async } from "q";
export default {
  data() {
    return {
      srcImgUrl: "",
      questionList: [],
      time: 10, //倒计时
      num: 0, //展示题目
      show: false, //解析展示
      rightId: null, //正确答案id
      start: true, ////是显示计时器 还是 状态
      type: true, //答案是对还是错
      timer: null, //销毁定时器
      showCenter: false, //闯关详情
      throughType: true, //闯关状态
      detailData: {},
      slat: "", //唯一值
      stratTime: null, //开始，
      endTime: null, //结束，
      errorNum: 0, //记录错误次数
      rightIndex: 0,
      webBtAnswerAnalysis: "",
      allNum: 0,
      disable: false
    };
  },

  methods: {
    next() {
      this.$router.push({
        path: "/stormPassAnswer",
        query: { id: this.$route.query.id }
      });
    },
    //关闭解析 进入下一题
    onClose() {
      this.show = false;
      this.num++;
      if (this.errorNum > this.detailData.webFaulttoleranceCount) {
        clearInterval(this.timer);
        this.showCenter = true;
        this.throughType = false;
        return false;
      }
      //如果答题模式是每道计时器
      if (this.detailData.webAnswerTimeType == 1) {
        console.log("mei");
        this.time = this.detailData.webAnswerTimeLimit;
      }
      //如果是总计时器
      this.stratTime = this.time;
      this.start = true; //是显示计时器 还是 状态
      this.type = true;
      this.rightId = null;
      if (this.num == this.questionList.length - 1) {
        console.log("最后一道");
        // 如果超过就是 失败的闯关详情
        console.log(this.errorNum);
        if (this.errorNum > this.detailData.webFaulttoleranceCount) {
          this.showCenter = true;
          this.throughType = false;
        } else {
          //如果答道最后一道 没有超过容错题数 就是成功闯关详情
          //闯关详情(成功)
          this.showCenter = true;
          this.throughType = true;
        }
      } else {
        // console.log("vshgsfsfhgsafdg", this.num);
        if (this.time > 1) {
          this.timer = setInterval(() => {
            if (this.time == 1) {
              clearInterval(this.timer);
              // console.log("每题时间超时");
              setTimeout(() => {
                this.getanswe(
                  this.questionList[this.num].webBtQuestionId,
                  this.num,
                  null,
                  null,
                  this.stratTime,
                  0
                );
              }, 1000);
            }
            this.time--;
          }, 1000);
        } else {
          //如果游戏模式为总时间模式 此时弹出闯关失败
          if (this.detailData.webAnswerTimeType == 2) {
            this.showCenter = true;
            this.throughType = false;
          } else {
            //每道题计时 并且 超过最大答错数量 此时也为答题失败
            if (this.errorNum > this.detailData.webFaulttoleranceCount) {
              this.showCenter = true;
              this.throughType = false;
            }
          }
        }
      }
    },
    //点击答案
    answerStart(id, int, index, anwId) {
      this.disable = true;
      this.endTime = this.time;
      let answerTime = null;
      if (int == 0) {
        answerTime = this.detailData.webAnswerTimeLimit - this.time;
      } else {
        answerTime = this.stratTime - this.endTime;
      }
      this.getanswe(id, int, index, anwId, answerTime);
    },

    //在来一局
    nextRound() {
      if (this.detailData.webAnswerCountLimitNum == 0) {
        Toast.fail("您的答题次数为0");
      } else {
        this.allNum = 0;
        location.reload();
      }
    },
    //获取答案
    getanswe(id, int, index, anwId, answerTime, type) {
      getBreakthroughAnswer({
        passtime: answerTime,
        questionNum: int + 1,
        salt: this.slat.substring(this.slat.length - 6),
        webBtAnswerId: anwId,
        webBtQuestionId: id
      }).then(({ data }) => {
        if (data.code == 200) {
          clearInterval(this.timer);
          // console.log("详情", data.data);
          this.rightId = data.data.webBtAnswerId;
          this.rightIndex = this.questionList[
            int
          ].webBtanswerEntities.findIndex(
            ele => ele.webBtAnswerId == this.rightId
          );
          this.webBtAnswerAnalysis = data.data.webBtAnswerAnalysis;
          if (data.data.checkFlag) {
            this.allNum += this.detailData.webAnswerScore;
            this.start = false;
            this.type = true;
            this.questionList[int].webBtanswerEntities[index].right = true;
          } else {
            //答题错误
            this.errorNum++;
            this.start = false;
            this.type = false;
            //特殊超时
            if (type == 0) {
              // console.log("chaoshi");
              this.questionList[int].webBtanswerEntities[
                this.rightIndex
              ].right = true;
            } else {
              // console.log("答案错去");
              this.questionList[int].webBtanswerEntities[
                this.rightIndex
              ].right = true;
              this.questionList[int].webBtanswerEntities[index].error = true;
            }
          }
          if (data.data.webBtAnswerAnalysis != "") {
            // console.log("有解析 ");
            //如果有解析
            setTimeout(() => {
              this.show = true;
              this.disable = false;
            }, 1000);
          } else {
            // console.log("无解析 ");
            let that = this;
            this.$nextTick(() => {
              setTimeout(function() {
                that.disable = false;
                that.onClose();
              }, 2000);
            });
          }
        }
      });
    },
    //获取数据
    async getDetails() {
      await getBreakthroughQuestion({
        webBreakthroughId: this.$route.query.id,
        salt: this.slat.substring(this.slat.length - 6)
      }).then(({ data }) => {
        if (data.code == 200) {
          console.log("KAISHI", data.data);
          document.title = data.data.webBreakthroughTitle;
          this.detailData = data.data;
          this.srcImgUrl = filePerviewPath({
            id: data.data.webBackgroundDetailImg,
            type: "cover"
          });

          data.data.webBtquestionEntities.forEach(ele => {
            ele.webBtanswerEntities.map(item => {
              item.error = false; //错误答案
              item.right = false; //争取答案
            });
          });
          //答案随机
          if (data.data.webAnswerType == 1) {
            data.data.webBtquestionEntities.map(async ele => {
              ele.webBtanswerEntities = await this.randomSortArray(
                ele.webBtanswerEntities
              );
            });
          }
          this.questionList = data.data.webBtquestionEntities;
          this.time = this.detailData.webAnswerTimeLimit;
        }
      });
    },
    //随机答案
    randomSortArray(arr) {
      var stack = [];
      while (arr.length) {
        //Math.random()：返回 [0,1) 之间的一个随机数
        var index = parseInt(Math.random() * arr.length); // 利用数组长度生成随机索引值
        stack.push(arr[index]); // 将随机索引对应的数组元素添加到新的数组中
        arr.splice(index, 1); // 删除原数组中随机生成的元素
      }
      return stack;
    }
  },

  async created() {
    //为一值
    this.slat = new Date().getTime() + "";
    //获取所有数据
    await this.getDetails();
  },
  async mounted() {
    this.timer = await setInterval(() => {
      this.time--;
      console.log(this.time);
      if (this.time == 0) {
        clearInterval(this.timer);
        // this.getDetails();
        setTimeout(() => {
          this.getanswe(
            this.questionList[this.num].webBtQuestionId,
            0,
            0,
            null,
            this.detailData.webAnswerTimeLimit,
            0
          );
        }, 1000);
      }
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style lang="scss" scoped>
.conter {
  background: #fff;
  width: 91.5%;
  margin: 1.72rem auto 0;
  position: relative;
  border-radius: 0.32rem;
  display: flex;
  flex-direction: column;
  .time {
    position: absolute;
    width: 1.44rem;
    height: 1.44rem;
    border: 0.1rem solid #fff;
    left: 50%;
    transform: translateX(-50%);
    top: -0.72rem;
    border-radius: 50%;
    text-align: center;
    box-sizing: border-box;
    > p {
      font-size: 0.56rem;
      color: #333;
      font-weight: 600;
      border: 0.1rem solid #5f73f9;
      border-radius: 50%;
      line-height: 1.04rem;
      height: 1.24rem;
      box-sizing: border-box;
      background: #fff;
    }
  }
  .questionList {
    color: #333;
    font-size: 0.32rem;
    padding: 0 0.4rem;
    height: 10rem;
    .order {
      color: #a9b4ff;
      font-size: 0.24rem;
      text-align: right;
      padding-top: 0.2rem;
      .num {
        font-size: 0.44rem;
        color: #5f73f9;
        font-weight: 500;
      }
    }
    .quesName {
      font-weight: 600;
      font-size: 0.34rem;
    }
    .answer {
      margin-top: 0.4rem;
      height: 79%;
      overflow: auto;
      li {
        padding: 0.22rem 0.28rem;
        background: #f9f9f9;
        margin-bottom: 0.28rem;
        border-radius: 0.08rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .right {
        background: #f1f3ff;
      }
      .error {
        background: #fff1f1;
      }
    }
  }
}
.bot {
  height: 16px;
  background: rgba(255, 255, 255, 0.6);
  width: 85%;
  margin: 0 auto;
  border-radius: 0 0 16px 16px;
}

.analysis {
  padding: 0.4rem 0.32rem 0.7rem 0.32rem;
  font-size: 0.28rem;
  .correct {
    color: #333333;
    margin-bottom: 0.24rem;
    span:first-child {
      color: #60cc78;
    }
  }
}
.details {
  font-size: 0.36rem;
  text-align: center;
  font-weight: 600;
}
/deep/.van-popup__close-icon--top-right {
  top: 0.6rem !important;
  right: 0.4rem !important;
}
.through {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .score {
    font-size: 0.32rem;
    color: #666666;
    span {
      font-size: 0.6rem;
      color: #5f73f9;
      font-weight: 600;
    }
  }
  .but {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 0.6rem;
  }
}
</style>